import React from 'react'
import { observer } from 'mobx-react'

import JobsViewerHeader from '../JobsViewerHeader'
import JobsTable from '../JobsTable'

import styles from './JobsViewer.sass'
import JobManagementViewModel from '../JobManagementViewModel'

interface JobsViewerProps {
  vm: JobManagementViewModel
}

export default observer(function JobsViewer({ vm }: JobsViewerProps) {
  return (
    <>
      <JobCount vm={vm} />
      <div className={styles.jobsViewer}>
        <JobsViewerHeader vm={vm} />
        <div className={styles.jobsTableContainer}>
          <JobsTable vm={vm} />
        </div>
      </div>
    </>
  )
})

const JobCount = observer(function JobCount({ vm }: JobsViewerProps) {
  const totalJobs = vm.searcher.totalJobs

  return (
    <div className={styles.jobCountContainer}>
      Jobs
      <span className={styles.resultCount}>({totalJobs ?? 0})</span>
    </div>
  )
})
